<div *ngIf="!isLoading">
  
  <!-- ====================== COMMON STYLES FOR ALL REPORTS ====================== -->
  <style>
    /* Print Styles */
  
    
    /* Screen Styles */
    #print-sectionBILL table {
      border-collapse: collapse;
      border: 1px solid black;
      width: 100%;
    }
    
    #print-sectionBILL th,
    #print-sectionBILL td {
      border: 1px solid black;
      padding: 8px;
      font-size: 13px;
    }
    
    #print-sectionBILL th {
      background-color: #f8f9fa;
      font-weight: bold;
    }
    
    .total-row {
      background-color: #e8f0ff !important;
      font-weight: bold !important;
    }
    
    .container {
      margin: 20px;
    }
  </style>

  <!-- ====================== REPORT TYPE 1: IN DETAIL ====================== -->
  <ng-container *ngIf="reportType == 'In Detail'">
    <div class="container mt-4" id="print-sectionBILL"style="Page=A4 portrait">
      
      <!-- Header Table (First Page Only) -->
     <table class="print-header">
  <tr>
    <th class="h-left" style="font-size:16px;">
      हिंदुस्तान प्रकाशन संस्था
    </th>
    <th class="h-center" style="font-size:16px;">
      Book Billing Report
    </th>
    <th class="h-right nowrap" style="font-size:16px;">
      दिनांक : {{ today | date:'dd-MM-yyyy' }}
    </th>
  </tr>

  <tr>
    <th class="h-left" style="font-size:16px;"
>
      विवेक पुस्तक प्रकाशन
    </th>
    <th class="h-center" style="font-size:16px;">
      In Detail
    </th>
    <th class="h-right nowrap" style="font-size:16px;">
      From {{ startDate | date:'dd-MM-yyyy' }} To {{ endDate | date:'dd-MM-yyyy' }}
    </th>
  </tr>
</table>

      
      <!-- Data Table (Column Headers Repeat) -->
     <table style="width: 100%; border-collapse: collapse; border: 1px solid black; margin-top: 0;">
        <thead>
          <!-- Column Headings -->
          <tr class="column-header">
            <th colspan="1" style="text-align: center; border: 1px solid black; padding: 8px;">Invoice No</th>
            <th colspan="1" style="text-align: center; border: 1px solid black; padding: 8px;">Invoice Date</th>
            <th colspan="1" style="text-align: center; border: 1px solid black; padding: 8px;width:17%;">Book Seller Name</th>
            <th colspan="1" style="text-align: center; border: 1px solid black; padding: 8px;">Representative Name</th>
            <th colspan="1" style="text-align: center; border: 1px solid black; padding: 8px;width:15%;">Office Representative Name</th>
            <th colspan="1" style="text-align: center; border: 1px solid black; padding: 8px;">Amount</th>
            <th colspan="1" style="text-align: center; border: 1px solid black; padding: 8px;">CGST</th>
            <th colspan="1" style="text-align: center; border: 1px solid black; padding: 8px;">SGST</th>
            <th colspan="1" style="text-align: center; border: 1px solid black; padding: 8px;">IGST</th>
            <th colspan="1" style="text-align: center; border: 1px solid black; padding: 8px;">Total GST</th>
            <th colspan="1" style="text-align: center; border: 1px solid black; padding: 8px;">Shipping</th>
            <th colspan="1" style="text-align: center; border: 1px solid black; padding: 8px;">Total Amt</th>
              <!-- <th style="text-align: center; border: 1px solid black; padding: 8px;">Credit Amt</th> -->
            <th colspan="1" style="text-align: center; border: 1px solid black; padding: 8px;">PAID Amt</th>
            <th colspan="1" style="text-align: center; border: 1px solid black; padding: 8px;">Credit Amt</th>
            <th colspan="1" style="text-align: center; border: 1px solid black; padding: 8px;">UNPAID Amt</th>
          </tr>
        </thead>

        <!-- Body Section -->
        <tbody>
          <tr *ngFor="let row of filteredAdvtInvoiceData">
            <td style="text-align: right; border: 1px solid black; padding: 8px;">{{ row.invoice_no }}</td>
            <td style="text-align: center; border: 1px solid black; padding: 8px;">{{ row.invoice_date | date:'dd-MM-yyyy' }}</td>
            <td style="text-align: left; border: 1px solid black; padding: 8px;">{{ row.name }}</td>
            <td style="text-align: left; border: 1px solid black; padding: 8px;">{{ row.rep_name }}</td>
            <td style="text-align: left; border: 1px solid black; padding: 8px;">{{ row.office_rep_name }}</td>
            <td style="text-align: right; border: 1px solid black; padding: 8px;">{{ row.invoice_total || 0 }}</td>
            <td style="text-align: right; border: 1px solid black; padding: 8px;">{{ row.cgst || 0 }}</td>
            <td style="text-align: right; border: 1px solid black; padding: 8px;">{{ row.sgst || 0  }}</td>
            <td style="text-align: right; border: 1px solid black; padding: 8px;">{{ row.igst || 0  }}</td>
            <td style="text-align: right; border: 1px solid black; padding: 8px;">{{ row.gst || 0 }}</td>
            <td style="text-align: right; border: 1px solid black; padding: 8px;">{{ row.shipping_charges || 0  }}</td>
            <td style="text-align: right; border: 1px solid black; padding: 8px;">{{ row.amount || 0  }}</td>
            <!-- <td style="text-align: right; border: 1px solid black; padding: 8px;">{{ row.crdtnote_total || 0  }}</td> -->
                        <td style="text-align: right; border: 1px solid black; padding: 8px;">{{ row.selecteamt || 0  }}</td>
                         <td style="text-align: right; border: 1px solid black; padding: 8px;">{{ row.crdtnote_total || 0  }}</td>
            <td style="text-align: right; border: 1px solid black; padding: 8px; ">
              {{ row.remaining_amt  }}
            </td>
          </tr>
        </tbody>

        <!-- Footer Total Row -->
        
          <tr class="total-row">
            <td colspan="5" style="text-align: center; border: 1px solid black; padding: 8px; font-weight: bold;background:#f9a14a;">Total</td>
            <td style="text-align: right; border: 1px solid black; padding: 8px; font-weight: bold;background:#f9a14a;">{{ total_invoice }}</td>
            <td style="text-align: right; border: 1px solid black; padding: 8px; font-weight: bold;background:#f9a14a;">{{ total_cgst }}</td>
            <td style="text-align: right; border: 1px solid black; padding: 8px; font-weight: bold;background:#f9a14a;">{{ total_sgst }}</td>
            <td style="text-align: right; border: 1px solid black; padding: 8px; font-weight: bold;background:#f9a14a;">{{ total_igst }}</td>
            <td style="text-align: right; border: 1px solid black; padding: 8px; font-weight: bold;background:#f9a14a;">{{ total_gst }}</td>
            <td style="text-align: right; border: 1px solid black; padding: 8px; font-weight: bold;background:#f9a14a;">{{ total_shipping }}</td>
            <td style="text-align: right; border: 1px solid black; padding: 8px; font-weight: bold;background:#f9a14a;">{{ total_amount }}</td>
             <td style="text-align: right; border: 1px solid black; padding: 8px; font-weight: bold;background:#f9a14a;">{{total_selecteamt}}</td>
             <td style="text-align: right; border: 1px solid black; padding: 8px; font-weight: bold;background:#f9a14a;">{{ total_crdtnote_total}}</td>
            <td style="text-align: right; border: 1px solid black; padding: 8px; font-weight: bold;background:#f9a14a;">{{ total_remaining }}</td>
          </tr>
       
      </table>
    </div>

    <!-- Action Buttons -->
   <div class="action-buttons noPrint">
  <button mat-raised-button color="primary" (click)="printPage4()">
    Print
  </button>

  <button mat-raised-button color="primary" (click)="exportExcel('In Detail')">
    Export
  </button>

  <button mat-button mat-dialog-close>
    Close
  </button>
</div>

  </ng-container>

  <!-- ====================== REPORT TYPE 2: BRIEFLY ====================== -->
  <ng-container *ngIf="reportType == 'Briefly'">
    <div class="container mt-4" id="print-sectionBILL">
      
      <!-- Header Table (First Page Only) -->
      <table class="print-header">
  <tr>
    <th class="h-left" style="font-size:16px;">
      हिंदुस्तान प्रकाशन संस्था
    </th>
    <th class="h-center" style="font-size:16px;">
      Book Billing Report
    </th>
    <th class="h-right nowrap" style="font-size:16px;">
      दिनांक : {{ today | date:'dd-MM-yyyy' }}
    </th>
  </tr>

  <tr>
    <th class="h-left" style="font-size:16px;"
>
      विवेक पुस्तक प्रकाशन
    </th>
    <th class="h-center" style="font-size:16px;">
      Briefly
    </th>
    <th class="h-right nowrap" style="font-size:16px;">
      From {{ startDate | date:'dd-MM-yyyy' }} To {{ endDate | date:'dd-MM-yyyy' }}
    </th>
  </tr>
</table>
      
      <!-- Data Table (Column Headers Repeat) -->
      <table style="width: 100%; border-collapse: collapse; border: 1px solid black; margin-top: 0;">
        <thead>
          <!-- Column Headers -->
          <tr class="column-header">
            <th colspan="1" style="border: 1px solid black; padding: 8px; text-align: center;">Invoice No.</th>
            <th colspan="1" style="border: 1px solid black; padding: 8px; text-align: center;">Invoice Date</th>
            <th colspan="1" style="border: 1px solid black; padding: 8px; text-align: center;">Book Seller Name</th>
            <th colspan="1" style="border: 1px solid black; padding: 8px; text-align: center;">Invoice Amt</th>
            <th colspan="1" style="border: 1px solid black; padding: 8px; text-align: center;">Receipt Amt</th>
            <th colspan="1" style="border: 1px solid black; padding: 8px; text-align: center;">Credit Amt</th>
            <th colspan="1" style="border: 1px solid black; padding: 8px; text-align: center;">Pending Amt</th>
          </tr>
        </thead>

        <!-- Body Section -->
        <tbody>
          <ng-container *ngFor="let data of filteredAdvtInvoiceDatabrifly; let i = index">
            <tr>
              <td style="border: 1px solid black; padding: 8px; text-align: center;">
                {{ data['invoice_no'] }}
              </td>
              <td style="border: 1px solid black; padding: 8px; text-align: center;">
                {{ data['invoice_date'] | date:'dd-MM-yyyy' }}
              </td>
              <td style="border: 1px solid black; padding: 8px; text-align: left;">
                {{ data['name'] }}
              </td>
              <td style="border: 1px solid black; padding: 8px; text-align: right;">
                {{ data['invoice_total']  }}
              </td>
              <td style="border: 1px solid black; padding: 8px; text-align: right;">
                {{ data['selecteamt']  }}
              </td>
              <td style="border: 1px solid black; padding: 8px; text-align: right;">
                {{ data['crdtnote_total']  }}
              </td>
              <td style="border: 1px solid black; padding: 8px; text-align: right;">
                {{ data['remaining_amt']  }}
              </td>
            </tr>
          </ng-container>
        </tbody>

        <!-- Footer Total Row -->
        
          <tr class="total-row" style="background:#f9a14a; font-weight:bold;" >
            <td colspan="3" style="border: 1px solid black; padding: 8px; font-weight: bold; text-align: center;background:#f9a14a;">
              Totals
            </td>
            <td style="border: 1px solid black; padding: 8px; text-align: right; font-weight: bold;background:#f9a14a;">
              {{ invoice_total  }}
            </td>
            <td style="border: 1px solid black; padding: 8px; text-align: right; font-weight: bold;background:#f9a14a;">
              {{ selecteamt  }}
            </td>
            <td style="border: 1px solid black; padding: 8px; text-align: right; font-weight: bold;background:#f9a14a;">
              {{ crdtnote_total  }}
            </td>
            <td style="border: 1px solid black; padding: 8px; text-align: right; font-weight: bold;background:#f9a14a;">
              {{ remaining_amt  }}
            </td>
          </tr>
        
      </table>
    </div>

    <!-- Action Buttons -->
  

     <div class="action-buttons noPrint">
  <button mat-raised-button color="primary" (click)="printPage()">
    Print
  </button>

  <button mat-raised-button color="primary" (click)="exportExcel('Briefly')">
    Export
  </button>

  <button mat-button mat-dialog-close>
    Close
  </button>
</div>
  </ng-container>

  <!-- ====================== REPORT TYPE 3: MONTHWISE ====================== -->
  <ng-container *ngIf="reportType === 'Monthwise'">
    <div class="container mt-4" id="print-sectionBILL">
      
      <!-- Header Table -->
      <table style="width: 100%; border-collapse: collapse; border: 1px solid black; margin-bottom: 0;">
        <thead>
          <tr>
            <th style="font-size: 18px; font-weight: bold; text-align:Center;padding: 8px; border: 1px solid black; width: 33%;">
              हिंदुस्तान प्रकाशन संस्था 
            </th>
            <th style="font-size: 18px; font-weight: bold; text-align: center; padding: 8px; border: 1px solid black; width: 34%;">
              Book Billing Report
            </th>
            <th style="font-size: 18px; text-align: right; padding: 8px; border: 1px solid black; width: 33%;">
              दिनांक - {{ today | date:"dd-MM-yyyy" }}
            </th>
          </tr>

          <tr>
            <th style="padding: 8px; font-weight: bold; font-size: 18px; text-align: center; border: 1px solid black;">
               विवेक पुस्तक प्रकाशन
            </th>
            <th style="font-size: 18px; font-weight: bold; text-align: center; padding: 8px; border: 1px solid black;">
              Monthwise
            </th>
            <th style="font-size: 16px; text-align: right; padding: 8px; border: 1px solid black;">
              Date : From {{ startDate | date:'dd-MM-yyyy' }} To {{ endDate | date:'dd-MM-yyyy' }}
            </th>
          </tr>
        </thead>
      </table>

      <!-- Data Table -->
      <table style="width: 100%; border-collapse: collapse; border: 1px solid black; margin-top: 0;">
        <thead>
          <tr>
            <th style="text-align: left; padding: 8px; border: 1px solid black; background-color: #f8f9fa; font-weight: bold;">
              Office Representative
            </th>
            <th *ngFor="let month of monthColumns" style="padding: 8px; border: 1px solid black; background-color: #f8f9fa; font-weight: bold; text-align: right;">
              {{ month }}
            </th>
            <th style="padding: 8px; border: 1px solid black; background-color: #f8f9fa; font-weight: bold; text-align: right;">
              Total
            </th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let data of filteredAdvtInvoiceDatamonthly">
            <td style="text-align: left; padding: 8px; border: 1px solid black; ">
              {{ data.office_rep_name }}
            </td>
            <td *ngFor="let month of monthColumns" style="padding: 8px; border: 1px solid black; text-align: right;">
              {{ getMonthValue(data, month) }}
            </td>
            <td style="padding: 8px; border: 1px solid black; font-weight: bold; text-align: right;">
              {{ data.grand_total }}
            </td>
          </tr>
        </tbody>

        <!-- Total Row -->
        <tfoot>
          <tr class="total-row">
            <td style="text-align: left; border: 1px solid black; padding: 8px; font-weight: bold;font-size: 16px;background:#f9a14a;">
              Monthwise Total
            </td>
            <td *ngFor="let month of monthColumns" style="border: 1px solid black; padding: 8px; text-align: right; font-weight: bold;font-size: 16px;background:#f9a14a;">
              {{ getMonthValue(totalRow, month) }}
            </td>
            <td style="border: 1px solid black; padding: 8px; text-align: right; font-weight: bold;font-size: 16px;background:#f9a14a;">
              {{ totalRow.grand_total }}
            </td>
          </tr>
        </tfoot>
      </table>
    </div>

    <!-- Action Buttons -->
   
       <div class="action-buttons noPrint">
  <button
    mat-raised-button
    color="primary"
    printSectionId="print-sectionBILL"
    ngxPrint>
    Print
  </button>

  <button
    mat-raised-button
    color="primary"
    (click)="exportExcel('Monthwise')">
    Export
  </button>

  <button mat-button mat-dialog-close>
    Close
  </button>
</div>

  </ng-container>



 <ng-container *ngIf="reportType === 'office Rep In Detail'">

  <div class="container mt-4" id="print-sectionBILL">

    <!-- ================= HEADER ================= -->
    <table style="width:100%; border-collapse:collapse; border:1px solid black;">
      <tr>
        <th  style="border:1px solid black; text-align:center; font-size:18px;">
          हिंदुस्तान प्रकाशन संस्था
        </th>
        <th  style="border:1px solid black; text-align:center; font-size:18px;">
          Book Billing Report
        </th>
        <th  style="border:1px solid black; text-align:center; font-size:18px;">
          दिनांक {{ today | date:'dd-MM-yyyy' }}
        </th>
      </tr>

      <tr>
        <th style="border:1px solid black; text-align:center; font-size:18px;">
          विवेक पुस्तक प्रकाशन
        </th>
        <th  style="border:1px solid black; text-align:center; font-size:18px;">
          Office Rep In Detail
        </th>
        <th colspan="1"  style="border:1px solid black; text-align:center; font-size:18px;">
          Date : From {{ startDate | date:'dd-MM-yyyy' }}
          To {{ endDate | date:'dd-MM-yyyy' }}
        </th>
      </tr>
    </table>

    <!-- ================= DATA TABLE ================= -->
    <table style="width:100%; border-collapse:collapse; border:1px solid black; margin-top:0;">
      <thead>
        <tr>
          <th colspan="1">Invoice No.</th>
          <th colspan="1">Invoice Date</th>
          <th colspan="1">Book Seller Name</th>
          <th colspan="1">Invoice Amount</th>
          <th colspan="1">Receipt Amount</th>
          <th colspan="1">Credit Note Amount</th>
          <th colspan="1">Pending Amount</th>
        </tr>
      </thead>

      <tbody>

        <!-- ================= OFFICE LOOP ================= -->
        <ng-container *ngFor="let office of officeRepData">

          <!-- Office Name -->
          <tr class="office-row">
            <td colspan="7" style="font-weight:bold; text-align:center;font-size: 15px;">
              Office Representative Name : {{ office.office_rep_name }}
            </td>
          </tr>

          <!-- ================= REP LOOP ================= -->
          <ng-container *ngFor="let rep of office.representatives">

            <!-- Rep Name -->
            <tr class="rep-row">
              <td colspan="7" style="font-weight:bold;">
                Representative Name : {{ rep.rep_name }}
              </td>
            </tr>

            <!-- Invoice Rows -->
            <ng-container *ngFor="let inv of rep.invoices">
              <tr>
                <td>{{ inv.invoice_no }}</td>
                <td>{{ inv.invoice_date | date:'dd-MM-yyyy' }}</td>
                <td style="text-align:left;">{{ inv.book_seller_name }}</td>
                <td style="text-align:right;">{{ inv.invoice_amount  }}</td>
                <td style="text-align:right;">{{ inv.receipt_amount  }}</td>
                <td style="text-align:right;">{{ inv.credit_note_amount  }}</td>
                <td style="text-align:right;">{{ inv.pending_amount  }}</td>
              </tr>
            </ng-container>

            <!-- Representative Total -->
            <tr class="rep-total"style="font-weight:bold;">
              <td colspan="3" style="text-align:right;font-weight:bold;">Representative Total :</td>
              <td style="text-align:right;font-weight:bold;">{{ rep.rep_totals.invoice_amount  }}</td>
              <td style="text-align:right;font-weight:bold;">{{ rep.rep_totals.receipt_amount  }}</td>
              <td style="text-align:right;font-weight:bold;">{{ rep.rep_totals.credit_note_amount  }}</td>
              <td style="text-align:right;font-weight:bold;">{{ rep.rep_totals.pending_amount  }}</td>
            </tr>

          </ng-container>

          <!-- ================= OFFICE TOTAL ================= -->
          <tr class="office-total">
            <td colspan="3" style="font-weight:bold;background:#f6c28b;">
              Office Representative Total : {{ office.office_rep_name }}
            </td>
            <td style="text-align:right;font-weight:bold;background:#f6c28b;">{{ office.office_totals.invoice_amount  }}</td>
            <td style="text-align:right;font-weight:bold;background:#f6c28b;">{{ office.office_totals.receipt_amount  }}</td>
            <td style="text-align:right;font-weight:bold;background:#f6c28b;">{{ office.office_totals.credit_note_amount  }}</td>
            <td style="text-align:right;font-weight:bold;background:#f6c28b;">{{ office.office_totals.pending_amount  }}</td>
          </tr>

        </ng-container>

        <!-- ================= GRAND TOTAL (ONLY ONCE) ================= -->
        <tr class="grand-total">
          <td colspan="3" style="text-align:center; font-size:16px;background:#f9a14a;font-weight:bold;">
            Grand Total
          </td>
          <td style="text-align:right;background:#f9a14a;font-weight:bold;">{{ grandTotal.invoice_amount  }}</td>
          <td style="text-align:right;background:#f9a14a;font-weight:bold;">{{ grandTotal.receipt_amount  }}</td>
          <td style="text-align:right;background:#f9a14a;font-weight:bold;">{{ grandTotal.credit_note_amount  }}</td>
          <td style="text-align:right;background:#f9a14a;font-weight:bold;">{{ grandTotal.pending_amount  }}</td>
        </tr>

      </tbody>
    </table>
  </div>

  <!-- ================= BUTTONS ================= -->
  

  <div class="action-buttons noPrint">
  <button mat-raised-button color="primary" (click)="printPage1()">
    Print
  </button>

  <button mat-raised-button color="primary" (click)="exportExcel('Office Rep In Detail')">
    Export
  </button>

  <button mat-button mat-dialog-close>
    Close
  </button>
</div>
  

</ng-container>


<ng-container *ngIf="reportType == 'Office Rep -Briefly'">

  <div class="container mt-4" id="print-sectionBILL">

    <!-- ================= HEADER ================= -->
          <table class="print-header">
  <tr>
    <th class="h-left" style="font-size:16px;">
      हिंदुस्तान प्रकाशन संस्था
    </th>
    <th class="h-center" style="font-size:16px;">
      Book Billing Report
    </th>
    <th class="h-right nowrap" style="font-size:16px;">
      दिनांक : {{ today | date:'dd-MM-yyyy' }}
    </th>
  </tr>

  <tr>
    <th class="h-left" style="font-size:16px;"
>
      विवेक पुस्तक प्रकाशन
    </th>
    <th class="h-center" style="font-size:16px;">
     Office Rep - Very Briefly
    </th>
    <th class="h-right nowrap" style="font-size:16px;">
      From {{ startDate | date:'dd-MM-yyyy' }} To {{ endDate | date:'dd-MM-yyyy' }}
    </th>
  </tr>
</table>

    <!-- ================= DATA TABLE ================= -->
    <table style="width:100%; border-collapse:collapse; border:1px solid black;">
      <thead>
        <tr style="font-weight:bold;">
          <th style="border:1px solid black;">Office Representative Name</th>
          <th style="border:1px solid black;">Total Invoice Amount</th>
          <th style="border:1px solid black;">Paid Amount</th>
           <th style="border:1px solid black;">Credit Amount</th>
          <th style="border:1px solid black;">Unpaid Amount</th>
        </tr>
      </thead>

      <tbody>

        <!-- ===== DATA ROWS ===== -->
        <tr *ngFor="let office of officeRepBriefData">
          <td style="border:1px solid black;">
            {{ office.office_rep_name }}
          </td>
          <td style="border:1px solid black; text-align:right;">
            {{ office.invoice_amount }}
          </td>
          <!-- <td style="border:1px solid black; text-align:right;">
            {{ office.receipt_amount  }}
          </td> -->
            <td style="border:1px solid black; text-align:right;">
            {{ office.receipt_amount  }}
          </td>
            <td style="border:1px solid black; text-align:right;">
            {{ office.crdtnote_total}}
          </td>
          <td style="border:1px solid black; text-align:right;">
            {{ office.pending_amount  }}
          </td>
        </tr>

        <!-- ===== GRAND TOTAL ===== -->
      <tr style="background:#f9a14a; font-weight:bold;">
  <td style="border:1px solid black;">Grand Total</td>

  <td style="border:1px solid black; text-align:right;">
    {{ grandTotal.invoice_amount  }}
  </td>

  <td style="border:1px solid black; text-align:right;">
    {{ grandTotal.receipt_amount  }}
  </td>

  <td style="border:1px solid black; text-align:right;">
    {{ grandTotal.credit_note_amount  }}
  </td>

  <td style="border:1px solid black; text-align:right;">
    {{ grandTotal.pending_amount  }}
  </td>
</tr>


      </tbody>
    </table>
  </div>

  <!-- ================= BUTTONS ================= -->
 
   <div class="action-buttons noPrint">
  <button mat-raised-button color="primary" (click)="printPageA4()">
    Print
  </button>

  <button mat-raised-button color="primary" (click)="exportExcel(' Office Rep - Briefly')">
    Export
  </button>

  <button mat-button mat-dialog-close>
    Close
  </button>
</div>

</ng-container>

<ng-container *ngIf="reportType == 'office Rep In Details'">

  <div class="container mt-4" id="print-sectionBILL">

    <!-- ================= HEADER ================= -->
       <table class="print-header">
  <tr>
    <th class="h-left" style="font-size:16px;">
      हिंदुस्तान प्रकाशन संस्था
    </th>
    <th class="h-center" style="font-size:16px;">
      Book Billing Report
    </th>
    <th class="h-right nowrap" style="font-size:16px;">
      दिनांक : {{ today | date:'dd-MM-yyyy' }}
    </th>
  </tr>

  <tr>
    <th class="h-left" style="font-size:16px;"
>
      विवेक पुस्तक प्रकाशन
    </th>
    <th class="h-center" style="font-size:16px;">
     Office Rep - Briefly
    </th>
    <th class="h-right nowrap" style="font-size:16px;">
      From {{ startDate | date:'dd-MM-yyyy' }} To {{ endDate | date:'dd-MM-yyyy' }}
    </th>
  </tr>
</table>

    <!-- ================= DATA TABLE ================= -->
    <table style="width:100%; border-collapse:collapse; border:1px solid black;">
      <thead>
        <tr style="font-weight:bold;">
          <th style="border:1px solid black;">Representative Name</th>
          <th style="border:1px solid black;">Total Invoice Amount</th>
          <th style="border:1px solid black;">Paid Amount</th>
          <th style="border:1px solid black;">credit note Amount</th>
          <th style="border:1px solid black;">Unpaid Amount</th>
        </tr>
      </thead>

      <tbody>

        <!-- ===== OFFICE LOOP ===== -->
        <ng-container *ngFor="let office of officeRepDetailData">

          <!-- OFFICE NAME ROW -->
          <tr>
            <td colspan="4"
                style="border:1px solid black; font-weight:bold; text-align:center;">
              Office Representative Name - {{ office.office_rep_name }}
            </td>
          </tr>

          <!-- REPRESENTATIVE ROWS -->
          <tr *ngFor="let rep of office.representatives">
            <td style="border:1px solid black;">
              {{ rep.rep_name }}
            </td>
            <td style="border:1px solid black; text-align:right;">
              {{ rep.rep_totals.invoice_amount  }}
            </td>
            <td style="border:1px solid black; text-align:right;">
              {{ rep.rep_totals.receipt_amount  }}
            </td>
            <td style="border:1px solid black; text-align:right;">
  {{ rep.rep_totals.crdtnote_total }}
</td>

            <td style="border:1px solid black; text-align:right;">
              {{ rep.rep_totals.pending_amount  }}
            </td>
          </tr>

          <!-- OFFICE TOTAL -->
          <tr style="background:#f6c28b; font-weight:bold;">
            <td style="border:1px solid black;">Office Representative Total</td>
            <td style="border:1px solid black; text-align:right;">
              {{ office.office_totals.invoice_amount  }}
            </td>
            <td style="border:1px solid black; text-align:right;">
              {{ office.office_totals.receipt_amount  }}
            </td>
              <td style="border:1px solid black; text-align:right;">
    {{ office.office_totals.crdtnote_total }}
  </td>
            <td style="border:1px solid black; text-align:right;">
              {{ office.office_totals.pending_amount  }}
            </td>
          </tr>

        </ng-container>

        <!-- ===== GRAND TOTAL ===== -->
        <tr style="background:#f9a14a; font-weight:bold;">
          <td style="border:1px solid black;">Grand Total</td>
          <td style="border:1px solid black; text-align:right;">
            {{ grandTotal.invoice_amount  }}
          </td>
          <td style="border:1px solid black; text-align:right;">
            {{ grandTotal.receipt_amount  }}
          </td>
            <td style="border:1px solid black; text-align:right;">
    {{ grandTotal.credit_note_amount }}
  </td>
          <td style="border:1px solid black; text-align:right;">
            {{ grandTotal.pending_amount }}
          </td>
        </tr>

      </tbody>
    </table>
  </div>

  <!-- ================= BUTTONS ================= -->
 

   <div class="action-buttons noPrint">
  <button mat-raised-button color="primary" (click)="printPageA41()">
    Print
  </button>

  <button mat-raised-button color="primary" (click)="exportExcel(' Office Rep - InDetails')">
    Export
  </button>

  <button mat-button mat-dialog-close>
    Close
  </button>
</div>

</ng-container>









</div>

<!-- Loading Spinner -->
<div *ngIf="isLoading" class="main-loading">
  <span class="loader"></span>
  <p>Loading...</p>
</div>